import '../../components/app/DemandedJobs.scss';
import '../../components/app/HireTalent.scss';
import './HireTalentPage.scss';
import { useParams } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import { ArrowBack } from '@mui/icons-material';
import Footer from '../app/Footer';
import history from '../../history';
import Form from '../utils/Form';
import CustomTextField from '../utils/CustomTextField';
import { useState } from 'react';


function HireTalentPage({talentData = {
    email: 'brucewayne@gmail.com',
    phone: '8754765232',
    message: 'Do you have a bulk order or a small order? Don\'t worry; I will be your ideal choice in that case as I have enough experience to deliver quality work efficiently. Also, my experience allows me to deliver all the work in just 24 hours of ordering. Speed is my first quality, so you can be free from worries about any work delay.'
}}) {
    const [formData, setFormData] = useState(talentData);
    const { talent } = useParams();

    const goBack = () => {
        history.back();
    }

    return (<div>
        <Navbar selected='Find Talents'></Navbar>
        <div className='hire-this-talent-form wrapper'>
            <div className='go-back-wrp' onClick={goBack}>
                    <ArrowBack/>
                    <span className='title'>Hire A Talent</span>
                </div>
            <Form formData={formData} handleInputChange={(e, d) => {
                const {name, value} = e?.target;
                d[name] = value;
                setFormData({...d});
            }} onSubmit={() => { console.log(formData) }} render={(data, onchange) =>
                <>
                    <CustomTextField label='Email' name='email' type='email' value={data?.email} onChange={onchange} />
                    <CustomTextField label='Phone Number' name='phone' type='number' value={data?.phone} onChange={onchange} />
                    <CustomTextField className='message' label='Message' rows={6} name='message' multiline={true} value={data?.message} onChange={onchange} />
                    <button className="next-btn" type='submit'>Submit</button>
                </>
            } />
        </div>
        <Footer></Footer>
    </div>);
}

export default HireTalentPage;